export default ({ request }) => ({
  SYS_EXPORT(taskName = '', context = {}) {
    return request({
      url: '/exportcenter/export',
      method: 'post',
      responseType: 'blob',
      data: {
        taskName,
        context,
      },
    })
  },
  SYS_EXPORT_TASK(taskName = '', context = {}) {
    return request({
      url: '/exportcenter/export/task',
      method: 'post',
      data: {
        taskName,
        context,
      },
    })
  },
})
